import flighttrack from "./flightTrack";
import crs from "./crs";
import cpl from "./cpl";
import hiwrap from "./hiwrap";
import nexrad from "./nexrad";
import npol from "./npol";

let nexradKATX= nexrad.katx;
let nexradKRTX= nexrad.krtx;
let nexradKLGX= nexrad.klgx;

export { flighttrack, crs, cpl, hiwrap, nexradKATX, nexradKRTX, nexradKLGX, npol }